import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Globe: FC<IconSvgProps> = ({ color, clss, width = 24, height = 24 }) => {
    const styles = {
        svg: {
            verticalAlign: 'middle',
            overflow: 'hidden',
            // Outline icon: inline so stylesheet rules like `svg { fill: currentColor }` (mobile menu) can't fill it.
            fill: 'none',
        },
    };

    return (
        <svg
            style={{ ...styles.svg }}
            className={clss}
            width={width}
            height={height}
            viewBox="0 0 24 24"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
            <path d="M2 12h20" />
        </svg>
    );
};

export default Globe;
